import { useEffect } from 'react';
import type { RecentRecord } from '@nest-recruit/shared';
import { useRecents } from '../stores/recents';

/**
 * A record page reports what it shows once it has loaded, for "recently viewed" (Q29); a page
 * that answers 403 or 404 passes `forgetId` so a record the person can no longer open drops out.
 */
export function useRecordVisit(record: Omit<RecentRecord, 'viewedAt'> | null, forgetId: string | null = null): void {
  const visit = useRecents((state) => state.visit);
  const forget = useRecents((state) => state.forget);
  const kind = record?.kind;
  const id = record?.id;
  const title = record?.title;
  const subtitle = record?.subtitle ?? null;
  const path = record?.path;
  useEffect(() => {
    if (!kind || !id || !title || !path) return;
    visit({ kind, id, title, subtitle, path });
  }, [kind, id, title, subtitle, path, visit]);
  useEffect(() => {
    if (forgetId) forget(forgetId);
  }, [forgetId, forget]);
}

/** The record's id when the server says the person can no longer open it. */
export function goneId(error: { readonly status: number } | null, id: string): string | null {
  return error && (error.status === 403 || error.status === 404) ? id : null;
}
